<template lang="pug">
  select.select(
    v-model="selectedValue"
    @change="change"
  )
    option(value="") {{title}}
    option(
      v-for="(option, index) in options"
      :value="option.value"
      :key="index"
    ) {{option.value}}
</template>

<script>
export default {
  name: 'map-select',
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: 'Выберите из списка',
    },
    selected: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selectedValue: this.selected,
    }
  },
  methods: {
    change(event) {
      this.$emit('change', event.target.value)
    },
  },
}
</script>

<style scoped lang="scss">
.select {
  width: 100%;
}
</style>
